import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { modalActions } from 'store/modal'
import {
  currentSurveyActions,
  submissionSurveyActions,
  uploadActions,
} from '../modules/WebSurvey'
import WebSurveyPage from '../components/WebSurveyPage'
import {
  onFetchInstrumentsByArchitecture,
  sendEvent,
} from '../../Activities/modules/Instruments'
import { isPauseResumeSupportedForInstrument } from '../../Activities/utils/instrumentUtils'

const mapStateToProps = (state) => {
  const { webSurveys, instruments, user, loading, strings, locales } = state
  const { webSurvey, currentSurvey, submissionSurvey } = webSurveys
  const { selectedLocale } = locales
  const isArticle = webSurvey.type === 'ARTICLE'

  return {
    currentSurvey,
    firstName: user.fname,
    isArticle,
    loading: loading.general,
    submissionLoading: loading.surveySubmission,
    pendingInstruments: instruments.pendingInstrumentsList,
    instruments: instruments.instrumentsList,
    selectedLocale,
    strings,
    submissionSurvey,
    webSurvey,
    isCaregiver: !!user.is_caregiver,
    studyId: user?.study_id,
    participantId: user.id,
    isPauseResumeSupported: isPauseResumeSupportedForInstrument(webSurvey),
    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study,

    reviewFunctionalitySupported: !!user?.study?.config?.food_diary,
  }
}

const mapDispatchToProps = Object.assign({}, submissionSurveyActions, {
  fetchPendingInstruments: () => onFetchInstrumentsByArchitecture(),
  fetchInstruments: () => onFetchInstrumentsByArchitecture(),
  setSubmissionSurvey: (survey) =>
    submissionSurveyActions.onSetSubmissionSurvey(survey),
  setAllRequiredAnswered: (bool, id, order) =>
    currentSurveyActions.setAllRequiredAnswered(bool, id, order),
  addQuestion: (ids, order, completedQuestion) =>
    currentSurveyActions.addQuestion(ids, order, completedQuestion),
  deleteStagedFile: (fileName) =>
    currentSurveyActions.deleteStagedFile(fileName),
  openModal: (modalProps) => modalActions.openModal(modalProps),
  closeModal: () => modalActions.closeModal(),
  sendEvent: (id, eventType, instrument) =>
    sendEvent(id, eventType, instrument),
  uploadV2File: (formData) => uploadActions.uploadV2File(formData),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props) => {
  const hasLoadedSurvey =
    Object.keys(props.webSurvey?.questions || {}).length > 0
  const hasActiveSurveyProgress =
    (props.currentSurvey || []).length > 0 ||
    (props.submissionSurvey?.questions || []).some(
      (q) => Array.isArray(q?.answer) && q.answer.length > 0,
    )
  // GOLD-12345: instance refetch uses a forced global loader. Swapping the
  // live survey for <Loader /> unmounts the page and looks like a refresh
  // that jumps back to the start. Keep the survey mounted once it has loaded.
  if (props.loading && !hasActiveSurveyProgress && !hasLoadedSurvey) {
    return <Loader />
  }
  return <WebSurveyPage {...props} />
})
